const formatTitleText = (value: string) => {
  return value
    ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    : "";
};

export default formatTitleText;
